import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  const href = 'https://digestion-superior.impultienda.ar/checkout';
  return <section id="pricing" className="bg-brand-dark relative" data-id="element-169">
      {/* Urgency countdown with dark red background - full width */}
      <div className="bg-[#1a0808] py-24" data-id="element-170">
        <div className="container mx-auto px-4" data-id="element-171">
          <div className="max-w-5xl mx-auto text-center" data-id="element-172">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-173">
              <h2 className="text-2xl font-bold mb-6 flex items-center justify-center gap-2 text-[#FFFFFF]" data-id="element-174">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
              </h2>
              <CountdownTimer data-id="element-175" />
              <p className="text-gray-400 mt-6 mb-4 flex items-center justify-center gap-2" data-id="element-176">
                <span className="text-yellow-500" data-id="element-177">⚠️</span> Después sube.{' '}
                <span className="text-white font-bold" data-id="element-178">No vuelve.</span>
              </p>

              <div className="max-w-md mx-auto bg-brand-black p-4 rounded-xl border border-red-500/20" data-id="element-179">
                <div className="flex justify-between text-sm mb-2 text-red-400 font-medium" data-id="element-180">
                  <span data-id="element-181">🔴 Cupos al precio de lanzamiento</span>
                  <span data-id="element-182">Quedan pocos</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2.5" data-id="element-183">
                  <div className="bg-red-500 h-2.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-184"></div>
                </div>
                <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-185">
                  68% de los cupos ya tomados
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Pricing card */}
      <div className="container mx-auto px-4 py-16 md:py-24" data-id="element-186">
        <div className="max-w-2xl mx-auto" data-id="element-187">
          <div className="text-center mb-8 md:mb-12" data-id="element-188">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-189">
              TU SISTEMA COMPLETO
            </h2>
          </div>

          {/* Single Offer */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black rounded-2xl md:rounded-3xl p-6 md:p-10 border-2 border-brand-green shadow-[0_0_20px_rgba(34,197,94,0.15)] flex flex-col" data-id="element-190">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-id="element-191">
              <div className="min-w-0" data-id="element-192">
                <div className="text-base md:text-lg font-bold text-brand-light mb-1" data-id="element-193">
                  🔬 SISTEMA DIGESTIÓN SUPERIOR™
                </div>
                <p className="text-sm text-gray-400 mb-2" data-id="element-194">
                  5 Volúmenes + 5 Bonos
                </p>
                <p className="text-sm text-brand-green font-medium" data-id="element-195">
                  5 guías completas en PDF + 5 bonos estratégicos de regalo.
                  Acceso inmediato.
                </p>
              </div>
              <div className="text-left md:text-right shrink-0" data-id="element-196">
                <div className="text-gray-500 line-through text-base" data-id="element-197">
                  $65.000
                </div>
                <div className="text-4xl md:text-5xl font-bold text-brand-green leading-tight" data-id="element-198">
                  $19.990
                </div>
                <div className="text-xs text-gray-400" data-id="element-199">ARS</div>
              </div>
            </div>
          </motion.div>

          {/* CTA Button */}
          <div className="max-w-lg md:max-w-2xl mx-auto mt-6 md:mt-10" data-id="element-200">
            <Button href={href} showBadges className="w-full py-4 text-base md:text-lg bg-brand-green hover:bg-brand-light" data-id="element-201">
              🔬 QUIERO MI SISTEMA AHORA
            </Button>
          </div>
        </div>
      </div>
    </section>;
}